<template>
  <b-row class="match-height">
    <b-col
      cols="12"
      md="4"
    >
      <CampaignReports />
    </b-col>

    <b-col
      cols="12"
      md="8"
    >
      <CampaignTable @update="$emit('update')" />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import CampaignReports from './CampaignReports.vue'
import CampaignTable from './CampaignTable.vue'

export default {
  components: {
    BRow,
    BCol,
    CampaignTable,
    CampaignReports,
  },
  computed: {
    ...mapGetters(['user']),
  },
}
</script>
